import styled from "styled-components/macro";
import { Content } from "./elements";

export default styled.div`
  width: 100%;
`

export const Dimming = styled.div`
  width: 100%;
  z-index: 3;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  animation: dimming-anim-enter 0.3s ease-in-out;

  @keyframes dimming-anim-enter {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
`

export const SheetContainer = styled(Content)`
  z-index: 4;
  width: 100%;
  background: white;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  position: fixed;
  bottom: 0;
  left: auto;
  right: auto;
  max-width: ${props => props.theme.maxWidth};
  padding: ${props => props.theme.padding};
  animation: bottom-sheet-enter-anim 0.3s ease-out both;
  direction: rtl;
  text-align: right;
  color: ${props => props.theme.colors.gray[0]};
  line-height: 25px;
  margin: 0 -15px;

  @keyframes bottom-sheet-enter-anim {
    from {
      bottom: -100%;
    }

    to {
      bottom: 0;
    }
  }
`
